import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import NightSafeIcon from 'Components/common/Icons/NightSafeIcon';
import {
    ROUTE_OPTIONS,
    ROUTE_OPTIONS_INTERNAL,
    ROUTE_OPTIONS_EXTERNAL,
    routeOptionsWithIcon,
} from 'Utils/constants';
import {Desktop} from 'Utils/ResponsiveUtil';
import {displayDistanceFromMetres} from 'Utils/unitOfMeasure';
import RouteOption from './RouteOption';
import './RouteOptions.scss';

const getRouteOptions = ({isKiosk, internalJourney}) => {
    let routeOptions = ROUTE_OPTIONS_EXTERNAL;
    if (internalJourney && !isKiosk) {
        routeOptions = ROUTE_OPTIONS_INTERNAL;
    } else if (isKiosk && internalJourney) {
        // in kiosk, internal journeys do not have drive mode
        routeOptions = ROUTE_OPTIONS_INTERNAL.filter(
            routeOption => routeOption !== ROUTE_OPTIONS.DRIVE
        );
    }

    return routeOptionsWithIcon.filter(({type}) => routeOptions.includes(type));
};

const RouteOptions = ({
    className,
    journeyExist,
    destination,
    selectRouteOption,
    selectedRouteOption,
    travelTimeMins,
    distanceMeters,
    isKiosk,
    internalJourney,
    displayNightSafe,
    unitOfMeasure,
    primaryColors,
}) => {
    const [isNightSafeActive, setIsNightSafeActive] = useState(false);

    return journeyExist ? (
        <div className={className}>
            <div className="route-options">
                <ul>
                    {getRouteOptions({isKiosk, internalJourney}).map(({type, icon}) => (
                        <RouteOption
                            key={type}
                            type={type}
                            destination={destination}
                            selectRouteOption={selectRouteOption}
                            selectedRouteOption={selectedRouteOption}
                            travelTimeMins={travelTimeMins}
                            Icon={icon}
                            isNightSafeActive={isNightSafeActive}
                            primaryColors={primaryColors}
                        />
                    ))}
                </ul>
                <div
                    className={classnames('night-safe', {
                        active: selectedRouteOption !== ROUTE_OPTIONS.DRIVE && isNightSafeActive,
                        disabled: selectedRouteOption === ROUTE_OPTIONS.DRIVE,
                    })}
                    style={{
                        display: displayNightSafe ? '' : 'none',
                    }}
                    onClick={() => {
                        if (selectedRouteOption !== ROUTE_OPTIONS.DRIVE) {
                            selectRouteOption(selectedRouteOption, !isNightSafeActive);
                            setIsNightSafeActive(!isNightSafeActive);
                        }
                    }}
                >
                    <NightSafeIcon />
                    <p>Night Safe</p>
                </div>
            </div>
            {!isKiosk &&
                distanceMeters > 0 && (
                    <Desktop>
                        <div className="route-options-distance">
                            {'Distance: '}
                            {displayDistanceFromMetres(unitOfMeasure, distanceMeters, true)}
                        </div>
                    </Desktop>
                )}
        </div>
    ) : (
        <div />
    );
};

RouteOptions.propTypes = {
    internalJourney: PropTypes.bool.isRequired,
    isKiosk: PropTypes.bool,
    journeyExist: PropTypes.bool.isRequired,
    destination: PropTypes.object,
    className: PropTypes.string,
    selectedRouteOption: PropTypes.oneOf(Object.values(ROUTE_OPTIONS)).isRequired,
    selectRouteOption: PropTypes.func.isRequired,
    travelTimeMins: PropTypes.number,
    distanceMeters: PropTypes.number,
    displayNightSafe: PropTypes.bool,
    unitOfMeasure: PropTypes.string,
    primaryColors: PropTypes.object,
};

export default RouteOptions;
